export const getWordsFromParagraph = (
  symbolsNumber: number,
  paragraph: string,
) => {
  const firstSymbols: string = paragraph.slice(0, symbolsNumber)
  const firstWords = firstSymbols.split(' ')
  const paragraphWords = paragraph.split(' ')

  const lastWordIndex = firstWords.length - 1

  return firstWords[lastWordIndex] === paragraphWords[lastWordIndex]
    ? firstSymbols
    : firstWords.slice(0, firstWords.length - 1).join(' ')
}
